<template>
  <div class="animated fadeIn">
    <b-tabs>
      <b-tab title="Submissions" active>
        <ProjectSubmissionTable :project="project" />
      </b-tab>

      <b-tab title="Samples">
        <ProjectSampleTable :project="project" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import ProjectSubmissionTable from './ProjectSubmissionTable.vue';
import ProjectSampleTable from './ProjectSampleTable.vue';

export default {
  name: 'ProjectDetailCardstack',
  components: {
    ProjectSubmissionTable,
    ProjectSampleTable
  },
  props: {
    project: {
      type: Object,
      default () {
        return null
      }
    }
  }
}
</script>
